exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".package-share-users-create img{height:auto;max-width:2.5rem;margin-right:1rem}.d-center{display:flex;align-items:center}.package-share-users-create .selected img{width:auto;max-height:23px;margin-right:.5rem}.package-share-users-create .v-select .dropdown li{border-bottom:1px solid rgba(112,128,144,.1)}.package-share-users-create .v-select .dropdown li:last-child{border-bottom:none}.package-share-users-create .v-select .dropdown li a{padding:10px 20px;width:100%;font-size:1.25em;color:#3c3c3c}.package-share-users-create .v-select .dropdown-menu .active>a{color:#fff}", ""]);

// exports
